import React, { useState, useMemo, useEffect } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import { z } from "zod";
import { Controller, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";

import i1 from "../../../../Assets/images/authbg.png";
import {
  catchAsync,
  checkResponse,
  removeUnderScoreAndCapitalizeFirstLetter,
} from "../../../../utilities/utilities";
import {
  UPDATE_PROMOCODE,
  ADD_PROMOCODE,
  GET_PROMOCODE_BY_ID,
} from "../../../../services/ApiCalls";
import {
  activeInActiveArr,
  discountTypeArr,
} from "../../../../utilities/const";
import moment from "moment";
import Loader from "../../../../components/Common/Loader";

const getSchema = () =>
  z
    .object({
      code: z.string({ required_error: "Code is  required" }),
      name: z.string({ required_error: "Coupan name is  required" }),
      status: z.boolean(),
      amount: z
        .string({ required_error: "Amount is required" })
        .refine((data) => !isNaN(data), {
          message: "Amount should be numeric",
        }),
      discount_type: z.string({ message: "Discount type is required" }),
      description: z.string(),
      date_expires: z.string({ message: "Date expires is required" }),
      start_date: z.string({ message: "Start date is required" }),
      maxUse: z.string({ message: "Max use is required" }).refine(
        (data) => {
          if (isNaN(data)) {
            return false;
          }
          return true;
        },
        { message: "Field should be numeric" }
      ),
    })
    .refine(
      (data) => {
        const startDate = new Date(data.start_date);
        const dateExpires = new Date(data.date_expires);

        // Ensure that start_date is before date_expires
        return startDate < dateExpires;
      },
      {
        // Custom error message if the refinement fails
        message: "Start date must be before expiry date",
        path: ["start_date"], // This pat
      }
    );

const AddPromoCode = () => {
  const [promoCodeDetails, setPromocodeDetails] = useState();
  const { id } = useParams();
  console.log("id>>>>>>>>", id);
  const schema = useMemo(() => getSchema(id), [id]);
  const navigate = useNavigate();
  const [loader, setLoader] = useState();

  const {
    register,
    handleSubmit,
    control,
    setValue,
    formState: { errors },
    watch,
  } = useForm({
    resolver: zodResolver(schema),
    defaultValues: {
      status: "active",
    },

    values: {
      code: promoCodeDetails?.code || "",
      name: promoCodeDetails?.name || "",
      maxUse: promoCodeDetails?.maxUse ? String(promoCodeDetails?.maxUse) : "",
      // status: promoCodeDetails?.status || "active",
      status: promoCodeDetails ? promoCodeDetails?.status === "active" : true,
      amount: promoCodeDetails?.amount?.toString() || "",
      discount_type: promoCodeDetails?.discount_type || "flat",
      description: promoCodeDetails?.description || "",
      // start_date: promoCodeDetails?.start_date || "",
      date_expires: promoCodeDetails?.date_expires || "",

      start_date: promoCodeDetails?.start_date?.slice(0, 16),

      date_expires: promoCodeDetails?.date_expires?.slice(0, 16),
    },
  });

  console.log(
    watch("start_date"),
    promoCodeDetails?.start_date &&
      new Date(promoCodeDetails?.start_date)?.toISOString()
  );

  const submitHandler = catchAsync(async (data) => {
    console.log(data, "dataPromocode>>>");
    const body = {
      ...data,
      ...(id && { _id: id }),
      status: data.status ? "active" : "inactive",
    };
    console.log("id", id, "and body promocode", body);
    const res = await (id ? UPDATE_PROMOCODE(body) : ADD_PROMOCODE(body));

    const success = checkResponse({ res, showSuccess: true });

    if (success) {
      navigate("/promocode");
    }
  });

  const getData = catchAsync(async () => {
    setLoader(true);
    const res = await GET_PROMOCODE_BY_ID(id);
    const success = checkResponse({
      res,
      setData: setPromocodeDetails,
      setLoader,
    });
  }, setLoader);

  useEffect(() => {
    if (id) getData();
  }, [id]);

  const handleCancel = () => {
    navigate("/promocode");
    // navigate("/system-access")
  };

  return (
    <>
      {loader && <Loader />}
      <section className="addPromo position-relative py-3">
        <Container>
          <Row>
            <Col lg="12">
              <div className="d-flex align-items-center gap-10">
                <Link
                  to="/promocode"
                  className="border d-flex align-items-center p-2 rounded"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12"
                    height="12"
                    viewBox="0 0 10 16"
                    fill="none"
                  >
                    <path
                      d="M8.64707 0.473344C8.55514 0.381188 8.44594 0.308072 8.32572 0.258184C8.20549 0.208296 8.07661 0.182617 7.94644 0.182617C7.81628 0.182617 7.68739 0.208296 7.56717 0.258184C7.44694 0.308072 7.33774 0.381188 7.24582 0.473344L0.667065 7.05209C0.593675 7.12533 0.53545 7.21233 0.495723 7.3081C0.455996 7.40387 0.435547 7.50654 0.435547 7.61022C0.435547 7.7139 0.455996 7.81657 0.495723 7.91234C0.53545 8.00811 0.593675 8.0951 0.667065 8.16834L7.24582 14.7471C7.63373 15.135 8.25915 15.135 8.64707 14.7471C9.03498 14.3592 9.03498 13.7338 8.64707 13.3458L2.9154 7.60626L8.65498 1.86668C9.03498 1.48668 9.03498 0.853344 8.64707 0.473344Z"
                      fill="#1E232C"
                      stroke="#1E232C"
                      stroke-width="0.2"
                    />
                  </svg>
                </Link>
                <h4 className="mb-0 py-3 fw-bold themeBlue text-capitalize">
                  {id ? "Edit Promo Code" : "Add Promo Code"}
                </h4>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <div
                className="formWrpper px-lg-5 p-md-4 p-3 rounded"
                style={{ border: "1px solid #dee2e6" }}
              >
                <Form onSubmit={handleSubmit(submitHandler)}>
                  <Row className="justify-content-between">
                    <Col lg="5" md="6" className="my-2">
                      <div className="py-2">
                        <label
                          htmlFor=""
                          className="form-label fw-sbold text-muted ps-2 m-0"
                        >
                          Coupon name:
                        </label>
                        <input
                          type="text"
                          required
                          placeholder="9dfuygh9uh"
                          className="form-control"
                          {...register("name")}
                        />
                        {errors?.code && (
                          <p className="text-danger m-0">
                            {errors?.code?.message}
                          </p>
                        )}
                      </div>
                      <div className="py-2">
                        <label
                          htmlFor=""
                          className="form-label fw-sbold text-muted ps-2 m-0"
                        >
                          Amount
                        </label>
                        <input
                          type="number"
                          placeholder="$20.00"
                          className="form-control"
                          required
                          {...register("amount")}
                        />
                        {errors?.amount && (
                          <p className="text-danger m-0">
                            {errors?.amount?.message}
                          </p>
                        )}
                      </div>
                      <div className="py-2">
                        <label
                          htmlFor=""
                          className="form-label fw-sbold text-muted ps-2 m-0"
                        >
                          Start Date
                        </label>
                        <input
                          type="datetime-local"
                          className="form-control"
                          {...register("start_date")}
                        />
                        {errors?.start_date && (
                          <p className="text-danger m-0">
                            {errors?.start_date?.message}
                          </p>
                        )}
                      </div>
                      <div className="py-2">
                        <label
                          htmlFor=""
                          className="form-label fw-sbold text-muted ps-2 m-0"
                        >
                          Description
                        </label>
                        <textarea
                          required
                          name=""
                          rows={5}
                          id=""
                          className="form-control h-auto"
                          {...register("description")}
                        ></textarea>
                        {errors?.description && (
                          <p className="text-danger m-0">
                            {errors?.description?.message}
                          </p>
                        )}
                      </div>
                    </Col>
                    <Col lg="5" md="6" className="my-2">
                      <div className="py-2">
                        <label
                          htmlFor=""
                          className="form-label fw-sbold text-muted ps-2 m-0"
                        >
                          Promo Code:
                        </label>
                        <input
                          type="text"
                          required
                          placeholder="REWARDS4U"
                          className="form-control"
                          {...register("code")}
                        />
                        {errors?.promocode && (
                          <p className="text-danger m-0">
                            {errors?.promocode?.message}
                          </p>
                        )}
                      </div>
                      <div className="py-2">
                        <label
                          htmlFor=""
                          className="form-label fw-sbold text-muted ps-2 m-0"
                        >
                          Discount Type
                        </label>

                        <Form.Select
                          className="form-control"
                          required
                          aria-label="Default select example"
                          {...register("discount_type")}
                        >
                          {discountTypeArr.map((item) => {
                            return (
                              <option value={item}>
                                {removeUnderScoreAndCapitalizeFirstLetter(item)}
                              </option>
                            );
                          })}
                        </Form.Select>
                        {errors?.discount_type && (
                          <p className="text-danger m-0">
                            {errors?.discount_type?.message}
                          </p>
                        )}
                      </div>
                      <div className="py-2">
                        <label
                          htmlFor=""
                          className="form-label fw-sbold text-muted ps-2 m-0"
                        >
                          Max Use
                        </label>
                        <input
                          type="number"
                          required
                          placeholder="Max Use"
                          className="form-control"
                          {...register("maxUse")}
                        />
                        {errors?.maxUse && (
                          <p className="text-danger m-0">
                            {errors?.maxUse?.message}
                          </p>
                        )}
                      </div>

                      <div className="py-2">
                        <label
                          htmlFor=""
                          className="form-label fw-sbold text-muted ps-2 m-0"
                        >
                          Expiry Date
                        </label>
                        <input
                          type="datetime-local"
                          className="form-control"
                          {...register("date_expires")}
                        />
                        {errors?.date_expires && (
                          <p className="text-danger m-0">
                            {errors?.date_expires?.message}
                          </p>
                        )}
                      </div>
                      <div className="py-2">
                        <label
                          htmlFor=""
                          className="form-label fw-sbold text-muted ps-2 m-0"
                        >
                          Set Status of Promotion
                        </label>
                        <Form.Check // prettier-ignore
                          type="switch"
                          id="custom-switch"
                          {...register("status")}
                        />
                        {errors?.status && (
                          <p className="text-danger m-0">
                            {errors?.status?.message}
                          </p>
                        )}
                      </div>
                    </Col>

                    <Col lg="12" className="my-2">
                      <div className="d-flex align-items-center justify-content-center gap-10">
                        <Button
                          type="submit"
                          onClick={handleCancel}
                          className="d-flex align-items-center justify-content-center commonBtn GreyBtn"
                        >
                          Cancel
                        </Button>
                        <Button
                          type="submit"
                          className="d-flex align-items-center justify-content-center commonBtn "
                        >
                          Submit
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default AddPromoCode;
